var map = {
	"./Section.js": 1740,
	"./section0.js": 6422,
	"./section1.js": 6730,
	"./section2.js": 451,
	"./section3.js": 2503,
	"./section4.js": 7495,
	"./section5.js": 9474,
	"./section6.js": 2212,
	"./section7.js": 7274,
	"./section8.js": 2423,
	"./section9.js": 7625,
	"./sectionDatenschutz.js": 9755,
	"./sectionHome.js": 5264,
	"./sectionImpressum.js": 6434,
	"./sectionKontakt.js": 2745,
	"./sectionMethoden.js": 1936,
	"./sectionNav.js": 3807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3396;